import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, onRetry }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8 text-center">
      <div className="rounded-full bg-danger/20 p-4">
        <AlertCircle className="h-8 w-8 text-danger" />
      </div>
      <div>
        <h3 className="text-lg font-semibold text-white mb-2">حدث خطأ</h3>
        <p className="text-gray-400">{message}</p>
      </div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="btn btn-primary mt-2"
        >
          إعادة المحاولة
        </button>
      )}
    </div>
  );
};